import type { CandleInterval } from "@/lib/live-candles/candle.types";

/** Interval names `/v1/candles` accepts (1D and 1W are capitalised). */
export type ServiceInterval =
  | "10s"
  | "30s"
  | "1m"
  | "2m"
  | "3m"
  | "4m"
  | "5m"
  | "10m"
  | "15m"
  | "30m"
  | "45m"
  | "1h"
  | "2h"
  | "3h"
  | "4h"
  | "6h"
  | "12h"
  | "1D"
  | "1W";

/** Intervals the stream's candles channel pushes. Others are polled over REST. */
const STREAMED_INTERVALS = new Set<ServiceInterval>([
  "10s",
  "30s",
  "1m",
  "2m",
  "3m",
  "4m",
  "5m",
  "10m",
  "15m",
  "30m",
  "1h",
  "3h",
  "6h",
  "12h",
  "1D",
  "1W",
]);

const SERVICE_INTERVALS: Record<CandleInterval, ServiceInterval> = {
  "1m": "1m",
  "5m": "5m",
  "15m": "15m",
  "30m": "30m",
  "1h": "1h",
  "4h": "4h",
  "1d": "1D",
};

export function toServiceInterval(interval: CandleInterval): ServiceInterval {
  return SERVICE_INTERVALS[interval];
}

export function isStreamedInterval(interval: ServiceInterval): boolean {
  return STREAMED_INTERVALS.has(interval);
}
